<template>
  <div class="TheSidebarMenuItem" :data-is-active="isActive">
    <div v-if="$slots.icon" class="TheSidebarMenuItem__icon">
      <slot name="icon" />
    </div>

    <UITextEllipsis v-if="$slots.label" class="TheSidebarMenuItem__label">
      <slot name="label" />
    </UITextEllipsis>

    <div v-if="$slots.contextMenu" class="TheSidebarMenuItem__context-menu">
      <slot name="contextMenu" />
    </div>
  </div>
</template>

<script setup lang="ts">
import UITextEllipsis from '../../ui/typography/UITextEllipsis.vue'

defineProps<{
  isActive?: boolean
}>()
</script>

<style lang="scss" scoped>
.TheSidebarMenuItem {
  --font-weight: 400;
  --color-text: var(--text-primary);
  --color-icon: var(--icon-secondary);
  display: flex;
  align-items: center;
  gap: var(---fds-global-space-xs);
  padding: var(---fds-global-space-xs);
  cursor: pointer;
  height: 2rem;
  min-width: 0;
  border-radius: var(--radius-xs);

  &:hover {
    background: var(--interactive-bg-tertiary-hover, #f2f2f3);
  }

  &[data-is-active='true'] {
    --font-weight: 500;
    --color-text: var(--text-accent);
    --color-icon: var(--icon-accent);
    background: var(--bg-elevated-primary, var(--bg-primary));

    &:hover {
      background: var(--interactive-bg-accent-hover);
    }
  }

  .TheSidebarMenuItem__icon {
    --size: 1.25rem;
    --color: var(--color-icon);
    flex-shrink: 0;
  }

  .TheSidebarMenuItem__label {
    @include font-body-small-medium;
    font-weight: var(--font-weight);
    color: var(--color-text);
    flex: 1 1 auto;
    min-width: 0;
  }

  .TheSidebarMenuItem__context-menu {
    flex-shrink: 0;
    margin-left: auto;
  }
}
</style>
